// Application Configuration
// This file centralizes all configuration values from environment variables

const config = {
  // API Settings
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
  },

  // Application Info
  app: {
    name: process.env.REACT_APP_NAME || 'MentorPro',
    programName: process.env.REACT_APP_PROGRAM_NAME || 'Programa de Mentoring',
    programYear: process.env.REACT_APP_PROGRAM_YEAR || new Date().getFullYear().toString(),
  },

  // Notifications
  notifications: {
    pollInterval: parseInt(process.env.REACT_APP_NOTIFICATION_POLL_INTERVAL || '30000'),
    enabled: process.env.REACT_APP_ENABLE_NOTIFICATIONS === 'true',
  },

  // UI Settings
  ui: {
    toastDuration: parseInt(process.env.REACT_APP_TOAST_DURATION || '3000'),
    defaultPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || '20'),
    maxPageSize: parseInt(process.env.REACT_APP_MAX_PAGE_SIZE || '100'),
  },

  // Meeting Settings
  meeting: {
    defaultPlatform: process.env.REACT_APP_DEFAULT_MEETING_PLATFORM || 'https://meet.google.com/',
    placeholder: process.env.REACT_APP_MEETING_PLACEHOLDER || 'https://meet.google.com/abc-defg-hij',
  },

  // File Upload
  fileUpload: {
    maxSize: parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '10485760'), // 10MB default
    allowedTypes: process.env.REACT_APP_ALLOWED_FILE_TYPES?.split(',') ||
      ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.png', '.jpg', '.jpeg'],
  },

  // Feature Flags
  features: {
    notifications: process.env.REACT_APP_ENABLE_NOTIFICATIONS === 'true',
    calendarSync: process.env.REACT_APP_ENABLE_CALENDAR_SYNC === 'true',
    videoCalls: process.env.REACT_APP_ENABLE_VIDEO_CALLS === 'true',
    fileSharing: process.env.REACT_APP_ENABLE_FILE_SHARING === 'true',
  },

  // External Services
  external: {
    googleCalendarApiKey: process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY || '',
    pusher: {
      key: process.env.REACT_APP_PUSHER_KEY || '',
      cluster: process.env.REACT_APP_PUSHER_CLUSTER || '',
    },
  },

  // Helper functions
  isProduction: () => process.env.NODE_ENV === 'production',
  isDevelopment: () => process.env.NODE_ENV === 'development',
  isTest: () => process.env.NODE_ENV === 'test',
};

export default config;